import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../reducers';
import { loginSuccess } from './auth.actions';
import { AuthService } from './auth.service';

@Injectable()
export class AuthResolver implements Resolve<boolean> {

  constructor(private store: Store<AppState>,
              private authService: AuthService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    let error = null;
    this.authService.isLoggedIn()
      .subscribe(response => this.store.dispatch(loginSuccess({user: response})),
                 err => {
                   console.log(err);
                   error = err;
                 });
    return !!error;
  }
}
